module.exports = __webpack_public_path__ + "static/img/oddvega_icon_hover.a3edb024.png";